export const getBcdBuffer = (value: number): number[] => {
  const ret: number[] = [];
  let length = 2;
  if (value > 9999 && value <= 99999999) {
    length = 4
  } else if (value > 99999999 && value <= 9999999999999999) {
    length = 8
  }
  for (var i = 0; i < length; i++) {
    ret[i] = (value % 10);
    value /= 10;
    ret[i] |= ((value % 10) << 4);
    value /= 10;
  }
  return ret;
}

export const bcd2Number = (value: number) => {
  const arr = getBcdBuffer(value);
  console.log(arr)
  if (arr.length == 2) {
    return arr[0] + (arr[1] << 8);
  }

  if (arr.length == 4) {
    return arr[0] + (arr[1] << 8) + (arr[2] << 16) + (arr[3] << 24);
  }

  throw new Error('Invaild bcd code.');
}
